export default __webpack_public_path__ + "static/media/eye-icon.0849c5eb.svg";